import { asLabel } from '@shure/shared/models';

export const MULTI_PLACEHOLDER_TRANSLATION_LABEL = asLabel('cloud.shared.labels.multi');
